// @note: this import might become conditional when SSR is introduced
import { Router } from "react-router-dom";

export default Router;
